export default (input: string, max = 30): string => {
  if (input.length <= max) {
    return input;
  }
  return input.substring(0, max).trim() + '...';
};
